import ActionBar from "./ActionBar";
import SmartCardBadge from "./SmartCardBadge";
import useVideoAutoPlay from "./useVideoAutoPlay";
import { Helmet } from "react-helmet";

export default function FeedPost({ post }) {
  const videoRef = useVideoAutoPlay();

  return (

    
    <div className="relative bg-black text-white mb-6 rounded-xl overflow-hidden shadow-lg">

<Helmet>
  <title>{post.caption}</title>
  <meta name="description" content={post.caption} />
  <meta property="og:title" content={post.caption} />
  <meta property="og:video" content={post.mediaUrl} />
  <meta property="og:image" content={post.chartUrl || post.mediaUrl} />
</Helmet>
      {/* VIDEO */}
      {post.mediaType === "video" && (
        <video
          ref={videoRef}
          src={post.mediaUrl}
          className="w-full h-[520px] object-cover"
          muted
          playsInline
          loop
        />
      )}

      {/* IMAGE POST */}
      {post.mediaType === "image" && (
        <img src={post.mediaUrl} className="w-full h-[420px] object-cover" />
      )}

      {/* RIGHT ACTION BAR */}
      <ActionBar postId={post.id} likes={post.likes} userId={post.userId} />

      {/* CHART PREVIEW */}
      {post.chartUrl && (
        <img src={post.chartUrl} className="w-full object-contain bg-gray-900 mt-2" />
      )}

      {/* CAPTION & ANALYSIS */}
      <div className="px-4 py-3">
        <h3 className="font-bold text-lg">{post.caption}</h3>

        {post.analysisPoints && (
          <ul className="text-sm text-gray-300 mt-2 space-y-1">
            {post.analysisPoints.map((point, i) => (
              <li key={i}>• {point}</li>
            ))}
          </ul>
        )}
      </div>

      {/* SMARTCARD BADGE */}
      <SmartCardBadge userId={post.userId} role={post.role} />

      {/* CATEGORY TAG */}
      <p className="px-4 pb-3 text-xs text-yellow-400">#{post.category}</p>
    </div>
  );
}
